import { useMemo } from 'react';

import { isCountryFR } from '@front/common/src/utils/country';

import { translate } from '@front/i18n';

import { mapOptionsNameToOptionsLabelFormat } from './utils';

const t = translate('screens.additional_information');

export const useDeclarativeSource = (isOptionObjectWithLabel = false) => {
  const commonDeclarativeSourceOptions = useMemo(
    () => [
      { name: t('.declarative_source_dropdown.word_of_mouth'), value: 'word_of_mouth' },
      { name: t('.declarative_source_dropdown.sponsorship'), value: 'sponsorship' },
      { name: t('.declarative_source_dropdown.google'), value: 'google' },
      { name: t('.declarative_source_dropdown.facebook'), value: 'facebook' },
      { name: t('.declarative_source_dropdown.instagram'), value: 'instagram' },
      { name: t('.declarative_source_dropdown.mailing'), value: 'mailing' },
      { name: t('.declarative_source_dropdown.email'), value: 'email' },
      { name: t('.declarative_source_dropdown.ad_display'), value: 'ad_display' },
      { name: t('.declarative_source_dropdown.press'), value: 'press' },
      { name: t('.declarative_source_dropdown.facebook_groups'), value: 'facebook_groups' },
      { name: t('.declarative_source_dropdown.app_store'), value: 'app_store' },
      { name: t('.declarative_source_dropdown.other'), value: 'other' },
    ],
    [],
  );

  const declarativeSourceOptionsFR = useMemo(
    () => [
      { name: t('.declarative_source_dropdown.job_board'), value: 'job_board' },
      { name: t('.declarative_source_dropdown.ad_tv'), value: 'ad_tv' },
    ],
    [],
  );

  const declarativeSourceOptions = [
    ...commonDeclarativeSourceOptions,
    ...(isCountryFR() ? declarativeSourceOptionsFR : []),
  ];

  const formattedDeclarativeSourceOptions = isOptionObjectWithLabel
    ? declarativeSourceOptions.map(mapOptionsNameToOptionsLabelFormat)
    : declarativeSourceOptions;

  return formattedDeclarativeSourceOptions;
};
